import {
  DynamicFormInputType,
  FormInputTypes,
} from '@components/_old/dynamicForm';
import { isEmpty } from '@utils/validationUtils';
import { FileType } from '@models/file';
import { IAccountImportInfo } from './index';

export const initialValues: IAccountImportInfo = {
  company: '',
  document: {
    id: '',
    location: '',
    path: '',
    fileName: '',
    length: undefined,
    contentType: '',
  },
};

export const inputs = (
  values: Record<string, any> = initialValues,
  downloadFuction: () => any
): Record<string, DynamicFormInputType> => ({
  company: {
    name: 'company',
    title: 'Company',
    type: FormInputTypes.newselect,
    value: !isEmpty(values.company) ? values.company : [],
    required: true,
    injectGlobalLov: {
      type: 'relatedCompanies',
      value: 'Id',
      display: 'Title',
    },
  },
  document: {
    name: 'document',
    title: 'Chart of Accounts',
    type: FormInputTypes.fileuploader,
    value: null,
    required: true,
    disabled: false,
    maxFileSizeInMB: 200,
    allowedFileTypes: [FileType.xls, FileType.xlsx],
    imageUrl: '',
    downloadLinks: [
      {
        displayName: 'Download Template',
        downloadUrl: 'example',
        action: downloadFuction,
      },
    ],
  },
});
